import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from 'site-modules/shared/components/skeleton/skeleton';

export function LoadingBackfill({ widgetName }) {
  return (
    <section aria-busy="true" aria-live="polite" data-tracking-parent={widgetName}>
      <div className="row mt-3" data-testid="shop-5016-backfill-loading">
        {[0, 1].map(index => (
          <div className="col-12 col-md-6 d-flex mb-0_75 mb-md-1_5" key={index}>
            <Skeleton style={{ minHeight: 557 }} className="d-block w-100 rounded-12" />
          </div>
        ))}
      </div>
    </section>
  );
}

LoadingBackfill.propTypes = { widgetName: PropTypes.string.isRequired };
